(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
  // Clear filters functionality
  $('#clear-filters').click(function() {
    $('.filter-checkbox').prop('checked', false);
    $('#price-min').val('');
    $('#price-max').val('');
    filterProducts(); // Reset product display after clearing filters
  });

  // Toggle filter options
  $('.filter-toggle').click(function() {
    $(this).toggleClass('active');
    $(this).next('.filter-options').slideToggle();
  });

  // View toggle for grid/list view
  $('#grid-view').click(function() {
    $('#grid-view').addClass('active');
    $('#list-view').removeClass('active');
    $('#product-list').removeClass('list-view').addClass('grid-view');
    refreshSlick();
  });

  $('#list-view').click(function() {
    $('#list-view').addClass('active');
    $('#grid-view').removeClass('active');
    $('#product-list').removeClass('grid-view').addClass('list-view');
    refreshSlick();
  });

  // Function to refresh slick sliders
  function refreshSlick() {
    // Safely unslick only if already initialized
    $('.product-image-wrapper').each(function() {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick');
      }
    });
    
    // Re-initialize slick
    initSlick();
  }

  // Function to initialize slick sliders
  function initSlick() {
    $('.product-image-wrapper').slick({
      infinite: true,
      dots: false,
      fade: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 1000,
      pauseOnHover: false,
      prevArrow: '<button type="button" class="slick-prev"><svg id="Layer_1" enable-background="new 0 0 128 128" height="14" viewBox="0 0 128 128" width="14" xmlns="http://www.w3.org/2000/svg"><path id="Left_Arrow_4_" d="m84 108c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656l40-40c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-37.172 37.172 37.172 37.172c1.563 1.563 1.563 4.094 0 5.656-.781.781-1.805 1.172-2.828 1.172z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg id="Layer_1" enable-background="new 0 0 128 128" height="14" viewBox="0 0 128 128" width="14" xmlns="http://www.w3.org/2000/svg"><path id="Right_Arrow_4_" d="m44 108c-1.023 0-2.047-.391-2.828-1.172-1.563-1.563-1.563-4.094 0-5.656l37.172-37.172-37.172-37.172c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l40 40c1.563 1.563 1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"/></svg></button>'
    });
  }

  // Initialize slick sliders on page load
  initSlick();

  // Start autoplay when hovering over the slider
  $(document).on('mouseenter', '.product-image-wrapper', function() {
    // Mouse enter: Start autoplay
    $(this).slick('slickPlay');
  }).on('mouseleave', '.product-image-wrapper', function() {
    // Mouse leave: Stop autoplay
    $(this).slick('slickPause');
  });

  // Handle pagination visibility
  var productCount = $('.product-card').length;
  if (productCount <= 1) {
    $('.pagination').css({
      position: 'absolute',
      bottom: 0,
      width: '100%'
    });
  }

  // Filter checkbox change event (Materials & Gemstones)
  $('.filter-checkbox').change(function() {
    filterProducts();
  });

  // Price filter button click event
  $('#price-filter-btn').click(function() {
    filterProducts();
  });

  // Allow pressing Enter in price fields to trigger filtering
  $('#price-min, #price-max').keypress(function(e) {
    if (e.which === 13) { // Enter key
      filterProducts();
    }
  });

  // Function to filter products based on all criteria
  function filterProducts() {
    // Get price filter values
    const minPrice = parseFloat($('#price-min').val()) || 0;
    const maxPrice = parseFloat($('#price-max').val()) || Number.MAX_SAFE_INTEGER;
    
    // Get selected materials
    const selectedMaterials = [];
    $('.filter-options input.filter-checkbox:not([value^="Gemstone_"]):checked').each(function() {
      selectedMaterials.push($(this).val());
    });
    
    // Get selected gemstones
    const selectedGemstones = [];
    $('.filter-options input[value^="Gemstone_"]:checked').each(function() {
      selectedGemstones.push($(this).val());
    });

    // Track visible product count for results display
    let visibleCount = 0;
    
    // Loop through each product and apply filters
    $('.product-card').each(function() {
      const productPrice = parseFloat($(this).data('price')) || 0;
      const productTags = String($(this).data('tags') || '');
      const productMaterial = $(this).data('jewelry-type') || '';
      
      // Check if product passes all active filters
      
      // 1. Price filter - check if product price is within range
      const priceMatch = (productPrice >= minPrice && 
                         (maxPrice === Number.MAX_SAFE_INTEGER || productPrice <= maxPrice));
      
      // 2. Material filter - check if product material matches any selected material
      // If no materials are selected, consider it a match
      const materialMatch = selectedMaterials.length === 0 || 
                           selectedMaterials.includes(productMaterial);
      
      // 3. Gemstone filter - check if product tags include any selected gemstone
      // If no gemstones are selected, consider it a match
      const gemstoneMatch = selectedGemstones.length === 0 || 
                           selectedGemstones.some(function(gemstone) {
                             return productTags.indexOf(gemstone) !== -1;
                           });
      
      // Only show product if it matches ALL active filters
      if (priceMatch && materialMatch && gemstoneMatch) {
        $(this).show();
        visibleCount++;
      } else {
        $(this).hide();
      }
    });

    // Update results count display
    const totalCount = $('.product-card').length;
    $('#results-count').text('Showing ' + visibleCount + ' of ' + totalCount + ' products');
    
    // Update pagination after filtering
    updatePagination();
  }

  // Function to update pagination visibility based on filtered results
  function updatePagination() {
    var visibleProducts = $('.product-card:visible').length;
    if (visibleProducts <= 1) {
      $('.pagination').css({
        position: 'absolute',
        bottom: 0,
        width: '100%'
      });
    } else {
      $('.pagination').css({
        position: 'relative'
      });
    }
  }
});

// Handle the cart functionality
document.addEventListener('DOMContentLoaded', function() {
  // Select all "Add to Cart" buttons
  const addToCartButtons = document.querySelectorAll('.add-to-cart');

  addToCartButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      // Get the variant ID (from the data-variant attribute)
      const variantId = event.target.getAttribute('data-variant');
      const quantity = 1; // You can adjust this based on your needs

      // Prepare the data for the AJAX request
      const data = {
        items: [{
          id: variantId,
          quantity: quantity
        }]
      };

      // Make the AJAX request to Shopify's /cart/add.js endpoint
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        console.log('Product added to cart:', data);
        // Update the cart UI (example: show a success message or update cart count)
        alert('Product added to cart!');
      })
      .catch(function(error) {
        console.error('Error adding product to cart:', error);
      });
    });
  });
});

window.onload = function() {
  // Select the hidden pagination div and the visible pagination div
  var hiddenPagination = document.querySelector('.pagination-hidden');
  var visiblePagination = document.querySelector('.pagination-visible');

  // Copy the inner HTML of the hidden pagination and paste it into the visible one
  if (hiddenPagination && visiblePagination) {
    visiblePagination.innerHTML = hiddenPagination.innerHTML;
  }
};

  // js for filter bar toggle in mobile 
  const toggleBtn = document.getElementById("filter-toggle");
const sidebar = document.querySelector(".filter-sidebar");
const closeBtn = document.querySelector(".sidebar-close");

toggleBtn.addEventListener("click", function () {
  this.classList.toggle("active");
  sidebar.classList.toggle("sidebar-active");
});

closeBtn.addEventListener("click", function () {
  sidebar.classList.remove("sidebar-active");
  toggleBtn.classList.remove("active");
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-grid"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
  // Initialize facet filters behavior
  function initFacetFilters() {
    // Toggle filter details
    $('.facets__summary').on('click', function() {
      const details = $(this).closest('details');
      if (!details.prop('open')) {
        // Close other open filters
        $('.facets__disclosure').not(details).prop('open', false);
      }
    });
    
    // Handle checkbox changes for filter submission
    $('.facets__item input[type="checkbox"]').on('change', function() {
      const form = $(this).closest('form');
      
      // For regular filtering, submit the form
      $(form).submit();
    });
    
    // Handle price range submission
    $('.price-range input').on('change', function() {
      const minInput = $('#Filter-Price-GTE');
      const maxInput = $('#Filter-Price-LTE');
      
      if (minInput.val() || maxInput.val()) {
        $(this).closest('form').submit();
      }
    });
  }
  
  // Initialize facet filters
  initFacetFilters();

  // Clear filters functionality
  $('#clear-filters').click(function() {
    // Clear all filter checkboxes
    $('.facets__item input[type="checkbox"]').prop('checked', false);
    
    // Clear price range inputs
    $('.price-range input').val('');
    
    // Reset the form which triggers clearing all filters in Shopify
    $('#FacetFiltersForm').submit();
  });

  // Toggle filter options
  $('.filter-toggle').click(function() {
    $(this).toggleClass('active');
    $(this).next('.filter-options').slideToggle();
  });

  // View toggle for grid/list view
  $('#grid-view').click(function() {
    $('#grid-view').addClass('active');
    $('#list-view').removeClass('active');
    $('#product-list').removeClass('list-view').addClass('grid-view');
    refreshSlick();
  });

  $('#list-view').click(function() {
    $('#list-view').addClass('active');
    $('#grid-view').removeClass('active');
    $('#product-list').removeClass('grid-view').addClass('list-view');
    refreshSlick();
  });

  // Function to refresh slick sliders
  function refreshSlick() {
    // Safely unslick only if already initialized
    $('.product-image-wrapper').each(function() {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick');
      }
    });
    
    // Re-initialize slick
    initSlick();
  }

  // Function to initialize slick sliders
  function initSlick() {
    $('.product-image-wrapper').slick({
      infinite: true,
      dots: false,
      fade: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 1000,
      pauseOnHover: false,
      prevArrow: '<button type="button" class="slick-prev"><svg id="Layer_1" enable-background="new 0 0 128 128" height="14" viewBox="0 0 128 128" width="14" xmlns="http://www.w3.org/2000/svg"><path id="Left_Arrow_4_" d="m84 108c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656l40-40c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-37.172 37.172 37.172 37.172c1.563 1.563 1.563 4.094 0 5.656-.781.781-1.805 1.172-2.828 1.172z"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg id="Layer_1" enable-background="new 0 0 128 128" height="14" viewBox="0 0 128 128" width="14" xmlns="http://www.w3.org/2000/svg"><path id="Right_Arrow_4_" d="m44 108c-1.023 0-2.047-.391-2.828-1.172-1.563-1.563-1.563-4.094 0-5.656l37.172-37.172-37.172-37.172c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l40 40c1.563 1.563 1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"/></svg></button>'
    });
  }

  // Initialize slick sliders on page load
  initSlick();

  // Start autoplay when hovering over the slider
  $(document).on('mouseenter', '.product-image-wrapper', function() {
    // Mouse enter: Start autoplay
    $(this).slick('slickPlay');
  }).on('mouseleave', '.product-image-wrapper', function() {
    // Mouse leave: Stop autoplay
    $(this).slick('slickPause');
  });

  // Handle pagination visibility
  var productCount = $('.product-card').length;
  if (productCount <= 1) {
    $('.pagination').css({
      position: 'absolute',
      bottom: 0,
      width: '100%'
    });
  }

  // Predictive search functionality
  const searchInput = $('.predictive-search-input');
  const searchResults = $('.predictive-search-results');
  
  // Show/hide search results
  searchInput.on('focus input', function() {
    const query = $(this).val().trim();
    
    if (query.length >= 2) {
      // Make AJAX call to Shopify's predictive search API
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
        .then(response => response.json())
        .then(data => {
          // Clear previous results
          searchResults.empty();
          
          // Check if there are any product results
          if (data.resources.results.products.length > 0) {
            // Add product results
            data.resources.results.products.forEach(product => {
              const productItem = `
                <a href="${product.url}" class="predictive-search-item">
                  <img src="${product.image || '/assets/no-image.jpg'}" alt="${product.title}">
                  <div>
                    <div>${product.title}</div>
                    <div>${product.price}</div>
                  </div>
                </a>
              `;
              searchResults.append(productItem);
            });
            
            // Show results
            searchResults.show();
          } else {
            // No results
            searchResults.append('<div class="predictive-search-item">No products found</div>');
            searchResults.show();
          }
        })
        .catch(error => {
          console.error('Error with predictive search:', error);
        });
    } else if (query.length === 0) {
      // Hide results if search is empty
      searchResults.hide();
    }
  });
  
  // Hide search results when clicking outside
  $(document).on('click', function(event) {
    if (!$(event.target).closest('.predictive-search-drawer').length) {
      searchResults.hide();
    }
  });

  // Handle pagination visibility
  function updatePagination() {
    var visibleProducts = $('.product-card:visible').length;
    if (visibleProducts <= 1) {
      $('.pagination').css({
        position: 'absolute',
        bottom: 0,
        width: '100%'
      });
    } else {
      $('.pagination').css({
        position: 'relative'
      });
    }
  }
});

// Handle the cart functionality
document.addEventListener('DOMContentLoaded', function() {
  // Select all "Add to Cart" buttons
  const addToCartButtons = document.querySelectorAll('.add-to-cart');

  addToCartButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      // Get the variant ID (from the data-variant attribute)
      const variantId = event.target.getAttribute('data-variant');
      const quantity = 1; // You can adjust this based on your needs

      // Prepare the data for the AJAX request
      const data = {
        items: [{
          id: variantId,
          quantity: quantity
        }]
      };

      // Make the AJAX request to Shopify's /cart/add.js endpoint
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        console.log('Product added to cart:', data);
        // Update the cart UI (example: show a success message or update cart count)
        alert('Product added to cart!');
      })
      .catch(function(error) {
        console.error('Error adding product to cart:', error);
      });
    });
  });
});

window.onload = function() {
  // Select the hidden pagination div and the visible pagination div
  var hiddenPagination = document.querySelector('.pagination-hidden');
  var visiblePagination = document.querySelector('.pagination-visible');

  // Copy the inner HTML of the hidden pagination and paste it into the visible one
  if (hiddenPagination && visiblePagination) {
    visiblePagination.innerHTML = hiddenPagination.innerHTML;
  }
  
  // Initialize facet filters for URL-based filtering
  initFacetFiltersFromUrl();
};

// Function to initialize facet filters from URL parameters
function initFacetFiltersFromUrl() {
  // Get URL search parameters
  const urlParams = new URLSearchParams(window.location.search);
  
  // Process filter parameters
  urlParams.forEach((value, key) => {
    if (key.startsWith('filter.')) {
      // Find the corresponding checkbox and mark as checked
      const filterName = key.replace('filter.', '');
      const checkbox = $(`input[name="${filterName}"][value="${value}"]`);
      
      if (checkbox.length) {
        checkbox.prop('checked', true);
        
        // Make sure the parent details element is open
        const details = checkbox.closest('details');
        if (details.length) {
          details.prop('open', true);
        }
      }
    } else if (key === 'filter.v.price.gte') {
      // Set min price
      $('#Filter-Price-GTE').val(value);
    } else if (key === 'filter.v.price.lte') {
      // Set max price
      $('#Filter-Price-LTE').val(value);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
